import React from 'react';
import { BrowserRouter, Route, Redirect, Switch } from 'react-router-dom';
import PropTypes from 'prop-types';
import Login from './login';
import Home from './home/Home';
import ListUsers from './users/ListUsers';
import ShowUser from './users/ShowUser';
import ShowCompany from './companies/ShowCompany';
import ListCompanies from './companies/ListCompanies';
import ListContracts from './contracts/ListContracts';
import ShowContract from './contracts/ShowContract';
import ListInvoices from './invoices/ListInvoices';
import ShowInvoice from './invoices/ShowInvoice';
import AssetsRouter from './assets/AssetsRouter';
import ListPeople from './people/ListPeople';
import Exception from '../components/Exceptions/Exception';
import useAuthContext from '../contexts/AuthContext';
import ShowPeople from './people/ShowPeople';
import ListTickets from './tickets/ListTickets';
import EditAndCreateTicket from './tickets/Edit&Create';
import ShowTicket from './tickets/ShowTicket';
import BasicLayout from '../layouts/BasicLayout';
import ListOrders from './Orders/ListOrders';
import EditAndCreateOrder from './Orders/Edit&Create';
import ShowOrder from './Orders/ShowOrder';
import ListTelecomInvoices from './telecomInvoices/ListTelecomInvoices';

export const PrivateRoute = ({
  location,
  component: Component,
  ...restProps
}) => {
  const authContext = useAuthContext();
  const splitPath = location.pathname.split('/');
  let path = '/';
  // eslint-disable-next-line prefer-destructuring
  if (splitPath[1]) path = `/${splitPath[1]}`;
  if (splitPath[2] && !['show', 'edit', 'create'].includes(splitPath[2]))
    // eslint-disable-next-line prefer-destructuring
    path = `/${splitPath[2]}`;

  return (
    <Route
      /* eslint-disable-next-line react/jsx-props-no-spreading */
      {...restProps}
      render={(props) =>
        authContext.isValid ? (
          <BasicLayout path={path}>
            {/* eslint-disable-next-line react/jsx-props-no-spreading */}
            <Component {...props} {...restProps} />
          </BasicLayout>
        ) : (
          <Redirect
            to={{ pathname: '/login', state: { from: props.location } }}
          />
        )
      }
    />
  );
};

PrivateRoute.propTypes = {
  component: PropTypes.func.isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string,
    state: PropTypes.shape({
      type: PropTypes.string,
      model: PropTypes.shape({
        name: PropTypes.string
      })
    })
  })
};

PrivateRoute.defaultProps = {
  location: { pathname: '/' }
};

const Router = () => {
  return (
    <BrowserRouter>
      <Switch>
        <Route path="/login/:token" component={Login} />
        <Route path="/login" component={Login} />
        <Route path="/register" component={Login} />
        <PrivateRoute exact path="/" component={Home} />
        <PrivateRoute exact path="/users" component={ListUsers} />
        <PrivateRoute exact path="/contracts" component={ListContracts} />
        <PrivateRoute exact path="/invoices" component={ListInvoices} />
        <PrivateRoute
          exact
          path="/telecomInvoices"
          component={ListTelecomInvoices}
        />
        <PrivateRoute
          exact
          path="/leaser"
          component={ListCompanies}
          type="LEASER"
        />
        <PrivateRoute
          exact
          path="/supplier"
          component={ListCompanies}
          type="SUPPLIER"
        />
        <PrivateRoute path="/users/show/:id" component={ShowUser} />
        <PrivateRoute path="/companies/show/:id" component={ShowCompany} />
        <PrivateRoute path="/contracts/show/:id" component={ShowContract} />
        <PrivateRoute path="/invoices/show/:id" component={ShowInvoice} />
        <PrivateRoute path="/people/show/:id" component={ShowPeople} />
        <PrivateRoute path="/tickets/show/:id" component={ShowTicket} />
        <PrivateRoute path="/assets" component={AssetsRouter} />
        <PrivateRoute exact path="/people" component={ListPeople} />
        <PrivateRoute exact path="/tickets" component={ListTickets} />
        <PrivateRoute
          exact
          path="/tickets/create"
          component={EditAndCreateTicket}
        />
        <PrivateRoute exact path="/orders" component={ListOrders} />
        <PrivateRoute
          exact
          path="/orders/create"
          component={EditAndCreateOrder}
        />
        <PrivateRoute path="/orders/edit/:id" component={EditAndCreateOrder} />
        <PrivateRoute path="/orders/show/:id" component={ShowOrder} />
        <PrivateRoute component={Exception} />
      </Switch>
    </BrowserRouter>
  );
};

export default Router;
